module.exports = __webpack_public_path__ + "img/pq-grupo-texts-bg-mobile.c461896d.png";